import { __read } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import { GuideBox, VerifyUtil, Icon, Typography, Button, TextField, Color } from "../../";
import { CircularProgress, circularProgressClasses, Box } from '@mui/material';
import CheckTwoToneIcon from '@mui/icons-material/CheckTwoTone';
function CustomCircularProgress(_a) {
    var _b;
    var color = _a.color;
    return (_jsxs(Box, { sx: { position: 'relative', display: 'flex', opacity: 0.3 }, children: [_jsx(CircularProgress, { variant: "determinate", sx: {
                    // color: (theme) => theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
                    color: color === "negative" ? Color.text.secondary : Color.primary.enable,
                }, size: 30, thickness: 4, value: 100 }), _jsx(CircularProgress, { variant: "indeterminate", disableShrink: true, sx: (_b = {
                        // color: (theme) => (theme.palette.mode === 'light' ? Color.primary.enable_strock : '#308fe8'),
                        color: color === "negative" ? Color.primaryNegative.white : Color.primary.enable_strock,
                        animationDuration: '550ms',
                        position: 'absolute',
                        left: 0
                    },
                    _b["& .".concat(circularProgressClasses.circle)] = {
                        strokeLinecap: 'round',
                    },
                    _b), size: 30, thickness: 4 })] }));
}
var StyledComponent = styled(function (props) {
    var _a = __read(React.useState(""), 2), baseUrl = _a[0], setBaseUrl = _a[1];
    var _b = __read(React.useState(""), 2), mapiKey = _b[0], setMapiKey = _b[1];
    var _c = __read(React.useState(false), 2), open = _c[0], setOpen = _c[1];
    React.useEffect(function () {
        if (!VerifyUtil.isExistQueryStrings('mapiKey'))
            setOpen(true);
        if (!VerifyUtil.isExistQueryStrings('redirectTo')) {
            setBaseUrl('https://moa-engineers.midasit.com:443');
        }
        ;
    }, []);
    var handleClose = function () { return setOpen(false); };
    var handleOk = function () {
        if (!props.preventRedirect) {
            window.location.search = "?redirectTo=".concat(baseUrl, "&mapiKey=").concat(mapiKey);
        }
        handleClose();
    };
    var handleBaseUriChange = function (e) {
        var url = e.target.value;
        var extractedUrl = VerifyUtil.extractProtocolDomainPort(url);
        if (extractedUrl) {
            var protocol = extractedUrl.protocol;
            var domain = extractedUrl.domain;
            var port = extractedUrl.port;
            setBaseUrl("".concat(protocol, "://").concat(domain, ":").concat(port));
        }
        else {
            setBaseUrl("https://moa-engineers.midasit.com:443");
        }
    };
    var handleMapiKeyChange = function (e) { return setMapiKey(e.target.value); };
    return (_jsx(Dialog, { open: open, sx: { backdropFilter: "blur(5px)" }, onClose: props.onClose, children: _jsx(GuideBox, { width: 400, fill: "1", padding: 4, children: _jsxs(GuideBox, { width: '100%', fill: "1", spacing: 3, children: [_jsxs(GuideBox, { width: '100%', fill: "2", spacing: 1, center: true, row: true, horSpaceBetween: true, children: [_jsxs(GuideBox, { width: "70%", spacing: 1, children: [_jsxs(GuideBox, { width: "100%", fill: "2", spacing: 1, row: true, children: [_jsx(Icon, { iconName: "Warning" }), _jsx(Typography, { children: "To use the plugin" })] }), _jsx(Typography, { children: "you need a base URI and an MAPI-key." })] }), _jsx(GuideBox, { width: "30%", horRight: true, children: props.loading ? _jsx(CustomCircularProgress, { color: "negative" }) : _jsx(CheckTwoToneIcon, { sx: { color: Color.text.secondary } }) })] }), _jsxs(GuideBox, { width: "100%", fill: "2", spacing: 1, row: true, horSpaceBetween: true, verCenter: true, opacity: props.loading ? 0.5 : 1, children: [_jsx(Typography, { variant: "h1", children: "Base URI" }), _jsx(TextField, { autoFocus: true, width: 250, placeholder: "https://moa-engineers.midasit.com:443", onChange: handleBaseUriChange, disabled: props.loading })] }), _jsxs(GuideBox, { width: "100%", fill: "2", spacing: 1, row: true, horSpaceBetween: true, verCenter: true, opacity: props.loading ? 0.5 : 1, children: [_jsx(Typography, { variant: "h1", children: "MAPI-Key" }), _jsx(TextField, { width: 250, placeholder: "MIDASIT Auth API Key", onChange: handleMapiKeyChange, disabled: props.loading })] }), _jsx(GuideBox, { show: true, width: "100%", fill: "2", center: true, children: _jsx(Button, { variant: "contained", color: "negative", onClick: handleOk, width: "100%", disabled: props.loading, children: "continue" }) })] }) }) }));
})(function () { return ({}); });
export default StyledComponent;
